if (!customElements.get('sbg-collection-search')) customElements.define('sbg-collection-search', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.root = this.closest('.hdt-main-collection-wrap');
if (!this.root) return;
this.input = this.querySelector('input');
this.status = this.querySelector('[role="status"]');
this.clearButton = this.querySelector('[data-clear]');
this.grid = this.root.querySelector('[id="products-' + this.dataset.section + '"]');
this.pagination = this.root.querySelector('[data-sbg-pagination]');
if (!this.grid) return;
this.initialized = true;
this.original = [...this.grid.children];
this.controller = new AbortController();
this.run = 0;
this.categoryInputs = [...this.root.querySelectorAll('[data-sbg-category]')];
this.categoryInputs.forEach(input => input.addEventListener('change', () => this.search()));
this.root.querySelector('[data-sbg-clear-categories]')?.addEventListener('click', () => { this.categoryInputs.forEach(input => input.checked = false); this.search(); });
this.initialRecords = this.readRecords(this.root);
this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.search(); });
this.clearButton.addEventListener('click', () => this.clear());
this.input.addEventListener('input', () => { if (!this.input.value.trim()) this.clear(); });
this.input.addEventListener('search', () => { if (!this.input.value.trim()) this.clear(); });
this.input.addEventListener('keydown', event => { if (event.key === 'Escape') this.clear(); });
}
disconnectedCallback() { this.controller?.abort(); }
normalize(value) { return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
readRecords(root) {
const grid = root.querySelector('[id="products-' + this.dataset.section + '"]');
const index = root.querySelector('[data-sbg-search-index]');
if (!index) throw new Error('Missing index');
const terms = JSON.parse(index.textContent);
if (!grid && !terms.length) return [];
if (!grid || grid.children.length !== terms.length) throw new Error('Incomplete collection');
return [...grid.children].map((node, index) => ({ node: node.cloneNode(true), text: this.normalize(typeof terms[index] === 'string' ? terms[index] : terms[index].text), tags: terms[index].tags || [] }));
}
async loadRecords() {
if (this.records) return this.records;
const pages = Number(this.dataset.pages);
const current = Number(this.dataset.page);
const records = new Map([[current, this.initialRecords]]);
for (let page = 1; page <= pages; page++) {
if (page === current) continue;
const url = new URL(location.href);
url.searchParams.set('page', String(page));
url.searchParams.set('section_id', this.dataset.section);
const response = await fetch(url, { signal: this.controller.signal });
if (!response.ok) throw new Error('Unavailable');
records.set(page, this.readRecords(new DOMParser().parseFromString(await response.text(), 'text/html')));
}
this.records = [...records.entries()].sort((a, b) => a[0] - b[0]).flatMap(entry => entry[1]);
return this.records;
}
showCards(nodes) {
for (const node of nodes) {
for (const card of [node, ...node.querySelectorAll('[can-reveal]')]) {
card.removeAttribute('can-reveal');
card.style.removeProperty('opacity');
card.style.removeProperty('transform');
card.style.removeProperty('visibility');
}
}
this.grid.replaceChildren(...nodes);
this.root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
}
async search() {
const query = this.input.value.trim();
const selected = this.categoryInputs.filter(input => input.checked).map(input => input.value);
if (!query && !selected.length) return this.restore();
const run = ++this.run;
this.clearButton.hidden = false;
this.status.textContent = this.dataset.loading;
this.setAttribute('aria-busy', 'true');
try {
const records = await this.loadRecords();
if (!this.isConnected || this.run !== run || this.input.value.trim() !== query) return;
const tokens = this.normalize(query).split(/\s+/).filter(Boolean);
const categoryTags = { gems: ['Loose Gemstones'], jewelry: ['Fine Jewelry', 'Rings', 'Signature Line'], crystals: ['Carvings'], minerals: ['Minerals'] };
const matches = records.filter(record => {
const words = record.text.split(/[^\p{L}\p{N}]+/u);
return (!selected.length || selected.some(category => categoryTags[category].some(tag => record.tags.includes(tag)))) && tokens.every(token => words.some(word => word.startsWith(token)));
});
this.showCards(matches.map(record => record.node.cloneNode(true)));
if (this.pagination) this.pagination.hidden = true;
this.status.textContent = matches.length ? this.dataset.results.replace('[count]', String(matches.length)) : this.dataset.empty;
} catch (error) {
if (error.name !== 'AbortError' && this.run === run) this.status.textContent = this.dataset.error;
} finally {
if (this.run === run) this.removeAttribute('aria-busy');
}
}
clear() {
this.input.value = '';
if (this.categoryInputs.some(input => input.checked)) return this.search();
this.restore();
}
restore() {
this.run++;
this.input.value = '';
this.clearButton.hidden = true;
this.status.textContent = '';
this.removeAttribute('aria-busy');
this.showCards(this.original);
if (this.pagination) this.pagination.hidden = false;
}
});